import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Gettouch from "../../../../components/getTouch/Gettouch";
import sodaAshLight from '../../../../assets/sodaAshLight.webp';
import sulphurBlackliquid from '../../../../assets/sulphurBlackliquid.webp';
import causticSodaflakes from '../../../../assets/causticSodaflakes.webp';
import pacLiquid from '../../../../assets/pacLiquid.webp';
import sodiumSulphate from '../../../../assets/sodiumSulphate.jpg';
import aluminiumSulphate from '../../../../assets/aluminiumSulphate.webp';
import bleachingPowder from '../../../../assets/bleachingPowder.webp';
import citricAcid from '../../../../assets/citricAcid.webp';
import calciumChlorideLumps from '../../../../assets/calciumChlorideLumps.webp';
import potassiumChloride from '../../../../assets/potassiumChloride.webp';
import diAmmoniumPhosphate from '../../../../assets/diAmmoniumPhosphate.webp';
import ferrousSulphateCrystal from '../../../../assets/ferrousSulphateCrystal.webp';
import hCL from '../../../../assets/hCL.webp';
import hydrogenPeroxide from '../../../../assets/hydrogenPeroxide.webp';
import maizeStarch from '../../../../assets/maizeStarch.webp';
import oxalicAcid from '../../../../assets/oxalicAcid.webp';
import precipitatedSilica from '../../../../assets/precipitatedSilica.jpg';
import precipitatedCalciumCarbonate from '../../../../assets/precipitatedCalciumCarbonate.webp';
import slesPowder from '../../../../assets/slesPowder.jpg';
import sulphamicAcid from '../../../../assets/sulphamicAcid.jpg';
import sodiumHypoChlorite from '../../../../assets/sodiumHypoChlorite.jpg';
import technicalGradeUrea from '../../../../assets/technicalGradeUrea.jpg';
import titaniumDioxide from '../../../../assets/titaniumDioxide.jpg';
import lemonChromeYellowPowder from '../../../../assets/lemonChromeYellowPowder.webp';
import scarletChromeOrange from '../../../../assets/scarletChromeOrange.jpg';
import middleChromeLightYellow from '../../../../assets/middleChromeLightYellow.webp';
import zincOxide from '../../../../assets/zincOxide.jpg';

const mineralsData = {
  "Soda Ash Light": {
    description: (
      <>
        <strong>Soda Ash Light</strong> is a versatile industrial chemical
        widely used in glass manufacturing, detergents, and water treatment
        processes. We offer premium-grade Soda Ash Light from trusted brands
        like <strong>Tata Chemicals</strong>, <strong>Nirma</strong> , and
        select <strong>Imported sources</strong> to meet diverse application
        needs. Our product is known for its high purity, consistent granulation,
        and reliable performance in both small-scale and large-scale operations.
        Whether you're in the textile, chemical, or soap industry, our Soda Ash
        Light ensures optimum results and cost-effectiveness. All variants are
        quality-checked and stored under ideal conditions to maintain product
        integrity. With flexible packaging options and prompt delivery, we
        support your supply chain with efficiency and trust. Contact us for bulk
        orders or to compare Tata, Nirma, and imported specifications.
      </>
    ),

    image: require("../../../../assets/sodaAshLight.webp"),
  },
  "Sulphur Black Liquid/Powder": {
    description: (
      <>
        <strong>Sulphur Black (Liquid & Powder)</strong> is a deep, rich black
        dye widely used in the textile industry for dyeing cotton and cellulose
        fibers. We supply both <strong>liquid and powder forms</strong> to suit
        various industrial dyeing processes, ensuring excellent color depth,
        fastness, and consistency. Our Sulphur Black is compatible with
        high-speed continuous dyeing and exhaust dyeing systems, offering
        superior penetration and wash-fast properties. Sourced from reliable
        manufacturers and formulated to meet stringent quality standards, our
        products are ideal for bulk and commercial dyeing operations. Whether
        you require high-concentration liquid or easy-to-store powder, we offer
        flexible packaging and competitive pricing. Technical support and dyeing
        guidance are available upon request to help you achieve the best
        results. Partner with us for consistent quality and on-time supply.
      </>
    ),
    image: require("../../../../assets/sulphurBlackliquid.webp"),
  },
  "Caustic soda Flakes /Lye": {
    description: (
      <>
        <strong>Caustic Soda</strong>, available in both{" "}
        <strong>flakes and lye</strong> (liquid) forms, is a highly versatile
        and essential chemical used across industries like textiles, paper,
        detergents, and water treatment. Our Caustic Soda Flakes are white,
        free-flowing, and high in purity, ideal for applications requiring solid
        alkali. The Caustic Soda Lye we supply is a clear, concentrated solution
        suitable for large-scale industrial use. Sourced from top manufacturers
        and tested for consistency, both forms ensure strong alkalinity and
        effective performance. We offer flexible packaging and bulk supply
        options tailored to your operational needs. With strict quality control
        and prompt logistics, we guarantee reliable and safe delivery every
        time. Reach out to compare specs or request MSDS for flakes or lye.
      </>
    ),
    image: require("../../../../assets/causticSodaflakes.webp"),
  },
  "PAC Powder & Liquid": {
    description: (
      <>
        <strong> Poly Aluminium Chloride (PAC)</strong> is a highly efficient
        coagulant used in water treatment, wastewater purification, and paper
        manufacturing. We supply{" "}
        <strong>PAC in both powder and liquid forms</strong>, catering to a
        range of industrial and municipal needs. Our <strong>PAC Powder</strong>{" "}
        is ideal for dry applications, offering high Al₂O₃ content and excellent
        performance in removing turbidity and suspended solids. The PAC Liquid
        provides ease of dosing and fast dissolution, perfect for continuous
        water treatment systems. All variants are sourced from certified
        manufacturers and meet international quality and safety standards. We
        offer flexible packaging, competitive rates, and technical support to
        ensure smooth application and compliance. Choose from various grades
        depending on your specific water treatment requirements.
      </>
    ),
    image: require("../../../../assets/pacLiquid.webp"),
  },
  "Sodium Sulphate Deepak/local/Birla": {
    description: (
      <>
        <strong>Sodium Sulphate</strong> is a widely used inorganic salt in
        industries such as textiles, detergents, glass, and paper. We supply
        high-quality Sodium Sulphate from reputed brands like{" "}
        <strong>Deepak Fertilisers</strong>, <strong>Birla</strong>, and
        reliable local manufacturers, offering options to suit both premium and
        cost-effective needs. Known for its excellent purity and stable chemical
        properties, our Sodium Sulphate ensures consistent performance in
        industrial processes. Whether you require <strong>anhydrous</strong> or{" "}
        <strong>crude</strong> grades, we provide tailored solutions in various
        packaging sizes. Our stock is quality-checked and stored under optimal
        conditions for maximum shelf life. With prompt delivery and competitive
        pricing, we support your production with dependable chemical supply.
        Contact us to compare grades and specifications from Deepak, Birla, or
        local sources.
      </>
    ),
    image: require("../../../../assets/sodiumSulphate.jpg"),
  },
  "Aluminium sulphate": {
    description: (
      <>
        <strong>Aluminium Sulphate</strong>, commonly known as{" "}
        <strong>alum</strong>, is a key chemical used in water purification,
        paper manufacturing, and textile dyeing. We supply high-quality
        Aluminium Sulphate in both lump and powder forms, ensuring excellent
        solubility and consistent performance. It is widely used as a coagulant
        to remove impurities in drinking water and wastewater treatment plants.
        Our product is sourced from trusted manufacturers and meets standard
        specifications for industrial and municipal applications. Available in
        various packaging options, it is suitable for bulk handling and
        long-term storage. With reliable logistics and competitive pricing, we
        ensure uninterrupted supply and customer satisfaction. Contact us for
        technical specifications or bulk purchase inquiries.
      </>
    ),
    image: require("../../../../assets/aluminiumSulphate.webp"),
  },
  "Bleaching Powder (GACL / Frasim)": {
    description: (
      <>
        <strong>Bleaching Powder</strong>, also known as{" "}
        <strong>Calcium Hypochlorite</strong>, is a powerful disinfectant widely
        used in water treatment, sanitation, and textile industries. We offer
        high-quality Bleaching Powder from trusted brands like{" "}
        <strong>GACL (Gujarat Alkalies and Chemicals Ltd.)</strong> and{" "}
        <strong>Frasim</strong>, known for their superior chlorine content and
        stability. Ideal for drinking water purification, sewage treatment, and
        bleaching applications, our product ensures effective germ and odor
        control. Available in moisture-resistant packaging, it retains its
        potency during storage and transit. We provide options in various grades
        and packing sizes to meet different industrial needs. With strict
        quality checks and prompt delivery, we ensure consistent supply and
        satisfaction. Get in touch for bulk orders or brand comparisons.
      </>
    ),
    image: require("../../../../assets/bleachingPowder.webp"),
  },
  "Citric Acid": {
    description: (
      <>
        <strong>Citric Acid</strong> is a versatile organic acid widely used in
        food, pharmaceuticals, cosmetics, and industrial applications. Known for
        its sour taste and excellent chelating properties, it serves as a pH
        regulator, preservative, and cleaning agent. We supply high-purity{" "}
        <strong>Citric Acid Monohydrate</strong> and <strong>Anhydrous</strong>{" "}
        forms sourced from reputed manufacturers to ensure consistent quality
        and performance. Ideal for use in food processing, beverage production,
        and detergent formulations, our citric acid meets international safety
        and quality standards. It is available in various packaging sizes to
        suit both small-scale and bulk requirements. With reliable stock, prompt
        dispatch, and competitive pricing, we support your supply chain with
        confidence. Contact us for specifications, MSDS, or to request a sample.
      </>
    ),
    image: require("../../../../assets/citricAcid.webp"),
  },
  "Calcium Chloride Powder & Lumps": {
    description: (
      <>
        <strong>Calcium Chloride</strong> is a highly effective and versatile
        chemical used in a variety of applications, including dust control,
        de-icing, construction, and water treatment. We offer both{" "}
        <strong>Calcium Chloride Powder</strong> and <strong>Lumps</strong>,
        each designed to meet specific industry needs. Our{" "}
        <strong>Calcium Chloride Powder</strong> is ideal for quick dissolution
        and is used extensively in the oil and gas industry, while the Lumps
        form is commonly used for road de-icing and moisture control. Sourced
        from reliable manufacturers, our products ensure consistent quality,
        high purity, and optimal performance. Available in bulk packaging or
        customized sizes, we guarantee safe and timely delivery. With
        competitive pricing and technical support, we are your trusted partner
        for Calcium Chloride solutions. Contact us for more details on
        specifications or bulk orders.
      </>
    ),
    image: require("../../../../assets/calciumChlorideLumps.webp"),
  },
  "Potassium Chloride": {
    description: (
      <>
        <strong>Potassium Chloride (KCl)</strong> is an essential chemical
        compound widely used in agriculture, water treatment, and as a potassium
        supplement in various industries. We offer high-quality{" "}
        <strong>Potassium Chloride</strong> in both <strong>granular</strong>{" "}
        and <strong>powder</strong> forms, suitable for fertilizers, de-icing,
        and pharmaceutical applications. Our product is sourced from reliable
        manufacturers, ensuring consistent purity and excellent performance. It
        is commonly used to enrich soil with essential potassium, vital for
        plant growth. Additionally, it is utilized in water softening and as a
        key ingredient in certain medical treatments. Available in various
        packaging sizes, our Potassium Chloride is cost-effective and delivered
        on time to meet your production needs. Contact us for more information
        or bulk order inquiries.
      </>
    ),
    image: require("../../../../assets/potassiumChloride.webp"),
  },
  "Di Ammonium Phosphate": {
    description: (
      <>
        <strong>Di Ammonium Phosphate (DAP)</strong> is a widely used
        high-quality fertilizer that provides essential nutrients like nitrogen
        and phosphorus to promote healthy plant growth. Ideal for agricultural
        applications, DAP helps increase crop yields by improving root
        development and flowering. Our <strong>DAP</strong> is sourced from
        reputable manufacturers and is available in both granular and powdered
        forms to suit different fertilization needs. With a balanced nutrient
        profile, it is perfect for a wide variety of crops, including cereals,
        vegetables, and fruit-bearing plants. The product is carefully stored
        and packaged to ensure its quality and consistency. Available in bulk or
        smaller packaging options, we provide competitive pricing and timely
        delivery to support your agricultural operations. Contact us for
        specifications or bulk orders.
      </>
    ),
    image: require("../../../../assets/diAmmoniumPhosphate.webp"),
  },
  "Ferrous Sulphate (Powder & Crystal)": {
    description: (
      <>
        <strong>Ferrous Sulphate</strong> is a versatile compound used in a
        range of applications, from water treatment and agriculture to
        pharmaceuticals and iron supplements. We offer both{" "}
        <strong>Ferrous Sulphate Powder</strong> and{" "}
        <strong>Ferrous Sulphate Crystals</strong>, each carefully formulated to
        meet high-quality standards. The Powder form is commonly used in water
        purification processes and as a micronutrient in fertilizers, while the
        Crystal form is ideal for industrial applications like pigments and iron
        fortification. Our product is sourced from trusted manufacturers and
        available in bulk or customized packaging options to meet your specific
        needs. With consistent quality and reliable supply, we are your go-to
        partner for Ferrous Sulphate. Contact us for product specifications,
        MSDS, or bulk order inquiries.
      </>
    ),
    image: require("../../../../assets/ferrousSulphateCrystal.webp"),
  },
  "H. C. L": {
    description: (
      <>
        <strong>Hydrochloric Acid (HCl)</strong> is a strong, highly versatile
        acid widely used in industries such as chemical manufacturing, metal
        cleaning, food processing, and water treatment. We offer high-purity{" "}
        <strong>Hydrochloric Acid</strong> in both <strong>liquid</strong> and{" "}
        <strong>industrial concentrations</strong>, ensuring it meets the needs
        of various industrial applications. Our HCl is sourced from trusted
        manufacturers and is known for its consistency, reliability, and
        effectiveness in removing rust, scaling, and other impurities. Available
        in a range of grades and packaging sizes, we provide tailored solutions
        for bulk orders or smaller quantities. With stringent quality controls
        and safe handling procedures, we guarantee safe, on-time delivery.
        Contact us for more details or bulk order inquiries.
      </>
    ),

    image: require("../../../../assets/hCL.webp"),
  },
  "Hydrogen Peroxide ( Megh mani , NPL & Tanlcer lood.)": {
    description: (
      <>
        <strong>Hydrogen Peroxide</strong> is a powerful oxidizing agent used in
        a wide range of applications, including bleaching, disinfection, and
        wastewater treatment. We offer high-quality{" "}
        <strong>Hydrogen Peroxide</strong> sourced from trusted manufacturers
        like <strong>Megh Mani</strong>, <strong>NPL</strong>, and{" "}
        <strong>Tanlcer Lood</strong>, ensuring reliability and consistent
        performance. Available in various concentrations, our product is ideal
        for industries such as textiles, food processing, and healthcare.
        Whether you require Hydrogen Peroxide for industrial cleaning,
        sterilization, or environmental applications, we provide it in
        convenient packaging options, including bulk quantities. With stringent
        quality controls and safe handling practices, we ensure the safe and
        timely delivery of our products. Contact us for more information or bulk
        order inquiries.
      </>
    ),
    image: require("../../../../assets/hydrogenPeroxide.webp"),
  },
  "Maize Starch": {
    description: (
      <>
        <strong>Maize Starch</strong>, derived from corn, is a highly versatile
        and essential ingredient used in a wide range of industries, including
        food, pharmaceuticals, textiles, and paper manufacturing. Our{" "}
        <strong>Maize Starch</strong> is sourced from reliable suppliers and is
        available in both <strong>powdered</strong> and{" "}
        <strong>granulated</strong> forms to meet diverse industrial needs. It
        is commonly used as a thickening agent in food products, a binder in
        pharmaceuticals, and as a key component in adhesives and coatings. With
        consistent quality, excellent performance, and a range of packaging
        options, we ensure that our Maize Starch meets the highest industry
        standards. We offer both bulk supply and smaller packaging, catering to
        your specific requirements. Contact us for detailed specifications or
        bulk order inquiries.
      </>
    ),
    image: require("../../../../assets/maizeStarch.webp"),
  },
  "Oxalic Acid": {
    description: (
      <>
        <strong>Oxalic Acid</strong> is a strong organic acid widely used for
        cleaning, bleaching, and metal treatment across various industries.
        Known for its excellent stain-removing and rust-cleaning properties, it
        is commonly used in textile, leather, and surface treatment
        applications. We supply high-purity <strong>Oxalic Acid</strong> in both{" "}
        <strong>crystal</strong> and <strong>powder forms</strong>, sourced from
        trusted manufacturers to ensure consistent quality and performance. It
        is also used in pharmaceutical formulations, as a reducing agent, and in
        certain laboratory processes. Available in durable, moisture-resistant
        packaging, we offer flexible supply options for both small and bulk
        requirements. With prompt delivery and competitive pricing, we support
        your operational needs with reliable service. Contact us for
        specifications, safety data, or order details.
      </>
    ),
    image: require("../../../../assets/oxalicAcid.webp"),
  },
  "Precipitated Silica": {
    description: (
      <>
        <strong>Precipitated Silica</strong> is a synthetic, amorphous form of
        silicon dioxide produced through controlled chemical reactions involving
        silicate solutions and acids. It appears as a fine, white, powdery
        substance with high purity and a porous structure. Known for its
        excellent reinforcing properties, it is widely used in rubber, tire, and
        footwear manufacturing. It also serves as a thickening, anti-caking, and
        free-flow agent in food, pharmaceuticals, and cosmetics. Precipitated
        silica enhances product performance through improved texture, stability,
        and durability. Its high surface area and chemical stability make it an
        ideal choice for various industrial applications. Custom grades are
        available to suit specific formulation needs.
      </>
    ),
    image: require("../../../../assets/precipitatedSilica.jpg"),
  },
  "Precipitated Calcium Carbonate": {
    description: (
      <>
        <strong>Precipitated Calcium Carbonate (PCC)</strong> is a high-purity,
        synthetic form of calcium carbonate produced by a controlled chemical
        reaction between calcium hydroxide and carbon dioxide. It appears as an
        ultra-fine, white powder with uniform particle size and excellent
        dispersion properties. PCC is widely used in paper, plastics, paints,
        rubber, and adhesives as a functional filler and coating pigment. It
        improves brightness, opacity, surface finish, and mechanical strength of
        end products. In pharmaceuticals and food industries, PCC is valued for
        its purity and bioavailability. Its fine particle size and customizable
        morphology make it suitable for specialized industrial formulations. We
        offer PCC in various grades to meet specific application requirements.
      </>
    ),
    image: require("../../../../assets/precipitatedCalciumCarbonate.webp"),
  },
  "SLES Powder & Liquid": {
    description: (
      <>
        <strong>Sodium Lauryl Ether Sulfate (SLES)</strong> is a widely used
        anionic surfactant available in both <strong>powder</strong> and{" "}
        <strong>liquid forms</strong>. It is known for its excellent foaming,
        emulsifying, and cleansing properties, making it a key ingredient in
        personal care products such as shampoos, body washes, and toothpastes.
        SLES is also extensively used in household cleaners, detergents, and
        industrial cleaning solutions. The <strong>liquid form</strong> offers
        ease of formulation and fast solubility, while the{" "}
        <strong>powder form</strong> ensures better handling, longer shelf life,
        and reduced shipping costs. Both forms are highly effective in removing
        oils and dirt while being gentle on skin. We supply SLES in customizable
        concentrations to meet diverse formulation needs.
      </>
    ),
    image: require("../../../../assets/slesPowder.jpg"),
  },
  "Sulphamic Acid": {
    description: (
      <>
        <strong>Sulphamic Acid</strong> is a versatile, non-volatile, white
        crystalline solid widely used as a cleaning and descaling agent in
        industrial and household applications. It offers excellent efficiency in
        removing limescale, rust, and mineral deposits without producing toxic
        fumes. Commonly used in the maintenance of boilers, heat exchangers, and
        metal surfaces, it is also found in toilet cleaners, detergents, and
        electroplating processes. Sulphamic Acid is safe to handle,
        biodegradable, and less corrosive compared to strong mineral acids. Its
        stable nature and high purity make it ideal for controlled pH reduction
        and industrial cleaning formulations. We offer various grades to suit
        cleaning, industrial, and technical applications.
      </>
    ),
    image: require("../../../../assets/sulphamicAcid.jpg"),
  },
  "Sodium HypoChlorite": {
    description: (
      <>
        <strong>Sodium Hypochlorite</strong> is a clear, pale yellow-green
        liquid commonly used as a powerful disinfectant and bleaching agent. It
        is widely applied in water treatment, sanitation, and cleaning
        industries for its strong oxidizing and antimicrobial properties. In
        household and industrial cleaning, it effectively removes stains,
        disinfects surfaces, and eliminates odors. It is also used in textile,
        pulp, and paper industries for bleaching and deodorizing. Sodium
        Hypochlorite plays a critical role in maintaining hygiene in municipal
        water systems and swimming pools. Available in various concentrations,
        it offers a cost-effective and reliable solution for large-scale
        disinfection and oxidation needs. We provide both industrial and
        commercial-grade options.
      </>
    ),
    image: require("../../../../assets/sodiumHypoChlorite.jpg"),
  },
  "Technical Grade Urea": {
    description: (
      <>
        <strong>Technical Grade Urea</strong> is a high-purity, white
        crystalline compound primarily used in industrial and chemical
        applications. Unlike agricultural-grade urea, it contains low levels of
        biuret and other impurities, making it suitable for resin production,
        adhesives, and as a raw material in formaldehyde-based compounds. It is
        widely used in the manufacture of urea-formaldehyde resins, melamine
        products, and coatings. Technical Grade Urea is also utilized in
        automotive systems (such as SCR for NOx reduction) and in various
        laboratory processes. It dissolves easily in water and offers consistent
        performance in industrial formulations. Available in various packaging
        sizes, it meets the stringent quality standards required for technical
        applications.
      </>
    ),
    image: require("../../../../assets/technicalGradeUrea.jpg"),
  },
  "Titanium Di-oxide": {
    description: (
      <>
        <strong>Titanium Dioxide (TiO₂)</strong> is a high-performance white
        pigment known for its exceptional brightness, opacity, and UV
        resistance. It is widely used in paints, coatings, plastics, paper,
        inks, and cosmetics due to its superior light-scattering properties. In
        the coatings and plastics industry, it enhances whiteness, gloss, and
        durability, while in sunscreens and cosmetics, it provides effective UV
        protection. Titanium Dioxide is available in <strong>rutile</strong> and{" "}
        <strong>anatase grades</strong>, each tailored for specific
        applications. It is chemically stable, non-toxic, and resistant to
        discoloration under UV light. We offer high-purity TiO₂ grades that meet
        industrial and regulatory standards for performance and safety.
      </>
    ),
    image: require("../../../../assets/titaniumDioxide.jpg"),
  },
  "Lemon Chrome (Yellow Powder)": {
    description: (
      <>
        <strong>Lemon Chrome (Yellow Powder)</strong> is a vibrant, yellow
        pigment primarily used in coatings, paints, and inks. It is known for
        its excellent color stability, bright hue, and high tinting strength,
        making it ideal for use in industrial and decorative applications. This
        pigment provides superior resistance to heat, light, and weathering,
        ensuring long-lasting color in both indoor and outdoor environments.
        Lemon Chrome is commonly used in automotive, construction, and art
        paints, as well as in the manufacturing of plastics and rubber. It is
        compatible with various solvents and resins, offering excellent
        dispersion. We supply high-quality Lemon Chrome pigment in powder form
        to meet diverse application needs.
      </>
    ),
    image: require("../../../../assets/lemonChromeYellowPowder.webp"),
  },
  "Scarlet Chrome (Orange)": {
    description: (
      <>
        <strong>Scarlet Chrome (Orange)</strong> is a vibrant, orange-colored
        pigment with exceptional brightness and high color strength. It is
        widely used in the production of paints, coatings, and inks, providing
        excellent durability and resistance to light and weathering. This
        pigment delivers outstanding performance in both indoor and outdoor
        applications, maintaining its vivid hue over time. Scarlet Chrome is
        commonly found in automotive paints, industrial coatings, plastics, and
        rubber products. It is compatible with various resins, solvents, and
        other materials, making it versatile for a range of formulations. Our
        high-quality Scarlet Chrome pigment is available in powder form, meeting
        the needs of various industrial and commercial applications.
      </>
    ),
    image: require("../../../../assets/scarletChromeOrange.jpg"),
  },
  "Middle Chrome (Light yellow)": {
    description: (
      <>
        <strong>Middle Chrome (Light Yellow)</strong> is a high-quality, light
        yellow pigment known for its bright, vibrant color and excellent
        opacity. It is commonly used in the production of paints, coatings,
        inks, and plastics, offering exceptional color stability and resistance
        to light and weathering. This pigment is ideal for use in automotive,
        industrial, and decorative coatings, where its light yellow tone
        provides a soft yet rich appearance. Middle Chrome delivers consistent
        performance and superior dispersion, making it highly compatible with
        various resins and solvents. It is a reliable choice for manufacturers
        seeking an economical and durable yellow pigment. We offer Middle Chrome
        in fine powder form to meet diverse application requirements.
      </>
    ),
    image: require("../../../../assets/middleChromeLightYellow.webp"),
  },
  "Zinc Oxide": {
    description: (
      <>
        <strong>Zinc Oxide (ZnO)</strong> is a versatile, white, powdery
        compound widely used in various industrial applications. It is known for
        its excellent UV-blocking properties, making it a key ingredient in
        sunscreens, cosmetics, and pharmaceuticals. Zinc Oxide also serves as a
        vital additive in rubber manufacturing, enhancing durability and
        resistance to heat and abrasion. In the paint industry, it improves the
        brightness and opacity of coatings. Additionally, it is used in the
        production of ceramics, glass, and electrical components due to its
        unique electrical properties. Zinc Oxide is chemically stable,
        non-toxic, and has antimicrobial properties, making it suitable for a
        broad range of applications. We offer high-purity Zinc Oxide to meet
        industrial and regulatory standards.
      </>
    ),
    image: require("../../../../assets/zincOxide.jpg"),
  },
};

const Chemicals = () => {
  const location = useLocation();
  const [selectedMinerals, setSelectedMinerals] = useState("Soda Ash Light");

  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const itemParam = searchParams.get('item') || searchParams.get('type');
    if (itemParam) {
      const keys = Object.keys(mineralsData);
      const match = keys.find(k => k.toLowerCase().includes(itemParam.toLowerCase()) || itemParam.toLowerCase().includes(k.toLowerCase()));
      if (match) {
        setSelectedMinerals(match);
      }
    }
  }, [location.search]);

  return (
    <>
      <div className="Minerals-Page-Desktop">
        <div className="Minerals-Main-Container">
          <div className="Minerals-Sub-Container">
            <h1>Chemicals</h1>
            <p>
              At our core, we specialize in delivering high-quality industrial
              and specialty chemicals that power a wide range of industries.
              From manufacturing and agriculture to pharmaceuticals and water
              treatment, our chemical solutions are formulated to meet the
              highest safety and performance standards. We believe in
              responsible sourcing, rigorous quality control, and sustainable
              practices. Our team of experts works closely with clients to
              provide tailored chemical solutions that drive efficiency and
              innovation. Whether you need raw materials or custom chemical
              blends, we ensure consistency and reliability in every shipment.
              With a commitment to compliance and environmental safety, we aim
              to be a trusted partner in your chemical supply chain. Explore our
              product range to find the right chemical solutions for your
              business needs.
            </p>
          </div>

          <div className="Minerals-Types-Main-Container">
            <div className="Minerals-Types-List-Conatiner">
              <h1>Types Of Chemicals</h1>
              <div style={{ maxHeight: "500px", overflowY: "auto" }}>
                {Object.keys(mineralsData).map((mineralsTypes) => (
                  <h2
                    key={mineralsTypes}
                    className={
                      selectedMinerals === mineralsTypes ? "active-salt" : ""
                    }
                    onClick={() => setSelectedMinerals(mineralsTypes)}
                    style={{ cursor: "pointer", margin: "20px 0" }}
                  >
                    {mineralsTypes}
                  </h2>
                ))}
              </div>
            </div>

            <div className="Minerals-Heading-Description-Container">
              <div className="Minerals-Row-Aline-Container">
                <img
                  src={mineralsData[selectedMinerals].image}
                  alt={selectedMinerals}
                  className="Minerals-Type-Image"
                />
                <div className="Minerals-Content-Container">
                  <h1>{selectedMinerals}</h1>
                  <p>{mineralsData[selectedMinerals].description}</p>
                </div>
              </div>
            </div>
          </div>

          <Gettouch />
        </div>
      </div>

      <div className="Minerals-Page-Mobile">
        <div className="Minerals-Main-Container">
          <div className="Minerals-Sub-Container">
            <h1>Chemicals</h1>
            <p>
              At our core, we specialize in delivering high-quality industrial
              and specialty chemicals that power a wide range of industries.
              From manufacturing and agriculture to pharmaceuticals and water
              treatment, our chemical solutions are formulated to meet the
              highest safety and performance standards. We believe in
              responsible sourcing, rigorous quality control, and sustainable
              practices. Our team of experts works closely with clients to
              provide tailored chemical solutions that drive efficiency and
              innovation. Whether you need raw materials or custom chemical
              blends, we ensure consistency and reliability in every shipment.
              With a commitment to compliance and environmental safety, we aim
              to be a trusted partner in your chemical supply chain. Explore our
              product range to find the right chemical solutions for your
              business needs.
            </p>

            <h2>Types of Chemicals</h2>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Soda Ash Light</h3>
              <img
                src={sodaAshLight}
                alt="sodaAshLight"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Soda Ash Light</strong> is a versatile industrial
                chemical widely used in glass manufacturing, detergents, and
                water treatment processes. We offer premium-grade Soda Ash Light
                from trusted brands like <strong>Tata Chemicals</strong>,{" "}
                <strong>Nirma</strong> , and select{" "}
                <strong>Imported sources</strong> to meet diverse application
                needs. Our product is known for its high purity, consistent
                granulation, and reliable performance in both small-scale and
                large-scale operations. Whether you're in the textile, chemical,
                or soap industry, our Soda Ash Light ensures optimum results and
                cost-effectiveness. All variants are quality-checked and stored
                under ideal conditions to maintain product integrity. With
                flexible packaging options and prompt delivery, we support your
                supply chain with efficiency and trust. Contact us for bulk
                orders or to compare Tata, Nirma, and imported specifications.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Sulphur Black Liquid/Powder</h3>
              <img
                src={sulphurBlackliquid}
                alt="sulphurBlackliquid"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Sulphur Black (Liquid & Powder)</strong> is a deep, rich
                black dye widely used in the textile industry for dyeing cotton
                and cellulose fibers. We supply both{" "}
                <strong>liquid and powder forms</strong> to suit various
                industrial dyeing processes, ensuring excellent color depth,
                fastness, and consistency. Our Sulphur Black is compatible with
                high-speed continuous dyeing and exhaust dyeing systems,
                offering superior penetration and wash-fast properties. Sourced
                from reliable manufacturers and formulated to meet stringent
                quality standards, our products are ideal for bulk and
                commercial dyeing operations. Whether you require
                high-concentration liquid or easy-to-store powder, we offer
                flexible packaging and competitive pricing. Technical support
                and dyeing guidance are available upon request to help you
                achieve the best results. Partner with us for consistent quality
                and on-time supply.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Caustic soda Flakes /Lye</h3>
              <img
                src={causticSodaflakes}
                alt="causticSodaflakes"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Caustic Soda</strong>, available in both{" "}
                <strong>flakes and lye</strong> (liquid) forms, is a highly
                versatile and essential chemical used across industries like
                textiles, paper, detergents, and water treatment. Our Caustic
                Soda Flakes are white, free-flowing, and high in purity, ideal
                for applications requiring solid alkali. The Caustic Soda Lye we
                supply is a clear, concentrated solution suitable for
                large-scale industrial use. Sourced from top manufacturers and
                tested for consistency, both forms ensure strong alkalinity and
                effective performance. We offer flexible packaging and bulk
                supply options tailored to your operational needs. With strict
                quality control and prompt logistics, we guarantee reliable and
                safe delivery every time. Reach out to compare specs or request
                MSDS for flakes or lye.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>PAC Powder & Liquid</h3>
              <img
                src={pacLiquid}
                alt="pacLiquid"
                className="Minerals-Type-Image"
              />
              <p>
                <strong> Poly Aluminium Chloride (PAC)</strong> is a highly
                efficient coagulant used in water treatment, wastewater
                purification, and paper manufacturing. We supply{" "}
                <strong>PAC in both powder and liquid forms</strong>, catering
                to a range of industrial and municipal needs. Our{" "}
                <strong>PAC Powder</strong> is ideal for dry applications,
                offering high Al₂O₃ content and excellent performance in
                removing turbidity and suspended solids. The PAC Liquid provides
                ease of dosing and fast dissolution, perfect for continuous
                water treatment systems. All variants are sourced from certified
                manufacturers and meet international quality and safety
                standards. We offer flexible packaging, competitive rates, and
                technical support to ensure smooth application and compliance.
                Choose from various grades depending on your specific water
                treatment requirements.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Sodium Sulphate Deepak/local/Birla</h3>
              <img src={sodiumSulphate} alt="sodiumSulphate" className="Minerals-Type-Image" />
              <p>
                <strong>Sodium Sulphate</strong> is a widely used inorganic salt
                in industries such as textiles, detergents, glass, and paper. We
                supply high-quality Sodium Sulphate from reputed brands like{" "}
                <strong>Deepak Fertilisers</strong>, <strong>Birla</strong>, and
                reliable local manufacturers, offering options to suit both
                premium and cost-effective needs. Known for its excellent purity
                and stable chemical properties, our Sodium Sulphate ensures
                consistent performance in industrial processes. Whether you
                require <strong>anhydrous</strong> or <strong>crude</strong>{" "}
                grades, we provide tailored solutions in various packaging
                sizes. Our stock is quality-checked and stored under optimal
                conditions for maximum shelf life. With prompt delivery and
                competitive pricing, we support your production with dependable
                chemical supply. Contact us to compare grades and specifications
                from Deepak, Birla, or local sources.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Aluminium sulphate</h3>
              <img
                src={aluminiumSulphate}
                alt="aluminiumSulphate"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Aluminium Sulphate</strong>, commonly known as{" "}
                <strong>alum</strong>, is a key chemical used in water
                purification, paper manufacturing, and textile dyeing. We supply
                high-quality Aluminium Sulphate in both lump and powder forms,
                ensuring excellent solubility and consistent performance. It is
                widely used as a coagulant to remove impurities in drinking
                water and wastewater treatment plants. Our product is sourced
                from trusted manufacturers and meets standard specifications for
                industrial and municipal applications. Available in various
                packaging options, it is suitable for bulk handling and
                long-term storage. With reliable logistics and competitive
                pricing, we ensure uninterrupted supply and customer
                satisfaction. Contact us for technical specifications or bulk
                purchase inquiries.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Bleaching Powder (GACL / Frasim)</h3>
              <img
                src={bleachingPowder}
                alt="bleachingPowder"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Bleaching Powder</strong>, also known as{" "}
                <strong>Calcium Hypochlorite</strong>, is a powerful
                disinfectant widely used in water treatment, sanitation, and
                textile industries. We offer high-quality Bleaching Powder from
                trusted brands like{" "}
                <strong>GACL (Gujarat Alkalies and Chemicals Ltd.)</strong> and{" "}
                <strong>Frasim</strong>, known for their superior chlorine
                content and stability. Ideal for drinking water purification,
                sewage treatment, and bleaching applications, our product
                ensures effective germ and odor control. Available in
                moisture-resistant packaging, it retains its potency during
                storage and transit. We provide options in various grades and
                packing sizes to meet different industrial needs. With strict
                quality checks and prompt delivery, we ensure consistent supply
                and satisfaction. Get in touch for bulk orders or brand
                comparisons.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Citric Acid</h3>
              <img
                src={citricAcid}
                alt="citricAcid"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Citric Acid</strong> is a versatile organic acid widely
                used in food, pharmaceuticals, cosmetics, and industrial
                applications. Known for its sour taste and excellent chelating
                properties, it serves as a pH regulator, preservative, and
                cleaning agent. We supply high-purity{" "}
                <strong>Citric Acid Monohydrate</strong> and{" "}
                <strong>Anhydrous</strong> forms sourced from reputed
                manufacturers to ensure consistent quality and performance.
                Ideal for use in food processing, beverage production, and
                detergent formulations, our citric acid meets international
                safety and quality standards. It is available in various
                packaging sizes to suit both small-scale and bulk requirements.
                With reliable stock, prompt dispatch, and competitive pricing,
                we support your supply chain with confidence. Contact us for
                specifications, MSDS, or to request a sample.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Calcium Chloride Powder & Lumps</h3>
              <img
                src={calciumChlorideLumps}
                alt="calciumChlorideLumps"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Calcium Chloride</strong> is a highly effective and
                versatile chemical used in a variety of applications, including
                dust control, de-icing, construction, and water treatment. We
                offer both <strong>Calcium Chloride Powder</strong> and{" "}
                <strong>Lumps</strong>, each designed to meet specific industry
                needs. Our <strong>Calcium Chloride Powder</strong> is ideal for
                quick dissolution and is used extensively in the oil and gas
                industry, while the Lumps form is commonly used for road
                de-icing and moisture control. Sourced from reliable
                manufacturers, our products ensure consistent quality, high
                purity, and optimal performance. Available in bulk packaging or
                customized sizes, we guarantee safe and timely delivery. With
                competitive pricing and technical support, we are your trusted
                partner for Calcium Chloride solutions. Contact us for more
                details on specifications or bulk orders.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Potassium Chloride</h3>
              <img
                src={potassiumChloride}
                alt="potassiumChloride"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Potassium Chloride (KCl)</strong> is an essential
                chemical compound widely used in agriculture, water treatment,
                and as a potassium supplement in various industries. We offer
                high-quality <strong>Potassium Chloride</strong> in both{" "}
                <strong>granular</strong> and <strong>powder</strong> forms,
                suitable for fertilizers, de-icing, and pharmaceutical
                applications. Our product is sourced from reliable
                manufacturers, ensuring consistent purity and excellent
                performance. It is commonly used to enrich soil with essential
                potassium, vital for plant growth. Additionally, it is utilized
                in water softening and as a key ingredient in certain medical
                treatments. Available in various packaging sizes, our Potassium
                Chloride is cost-effective and delivered on time to meet your
                production needs. Contact us for more information or bulk order
                inquiries.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Di Ammonium Phosphate</h3>
              <img
                src={diAmmoniumPhosphate}
                alt="diAmmoniumPhosphate"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Di Ammonium Phosphate (DAP)</strong> is a widely used
                high-quality fertilizer that provides essential nutrients like
                nitrogen and phosphorus to promote healthy plant growth. Ideal
                for agricultural applications, DAP helps increase crop yields by
                improving root development and flowering. Our{" "}
                <strong>DAP</strong> is sourced from reputable manufacturers and
                is available in both granular and powdered forms to suit
                different fertilization needs. With a balanced nutrient profile,
                it is perfect for a wide variety of crops, including cereals,
                vegetables, and fruit-bearing plants. The product is carefully
                stored and packaged to ensure its quality and consistency.
                Available in bulk or smaller packaging options, we provide
                competitive pricing and timely delivery to support your
                agricultural operations. Contact us for specifications or bulk
                orders.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Ferrous Sulphate (Powder & Crystal)</h3>
              <img
                src={ferrousSulphateCrystal}
                alt="ferrousSulphateCrystal"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Ferrous Sulphate</strong> is a versatile compound used
                in a range of applications, from water treatment and agriculture
                to pharmaceuticals and iron supplements. We offer both{" "}
                <strong>Ferrous Sulphate Powder</strong> and{" "}
                <strong>Ferrous Sulphate Crystals</strong>, each carefully
                formulated to meet high-quality standards. The Powder form is
                commonly used in water purification processes and as a
                micronutrient in fertilizers, while the Crystal form is ideal
                for industrial applications like pigments and iron
                fortification. Our product is sourced from trusted manufacturers
                and available in bulk or customized packaging options to meet
                your specific needs. With consistent quality and reliable
                supply, we are your go-to partner for Ferrous Sulphate. Contact
                us for product specifications, MSDS, or bulk order inquiries.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>H. C. L</h3>
              <img
                src={hCL}
                alt="hCL"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Hydrochloric Acid (HCl)</strong> is a strong, highly
                versatile acid widely used in industries such as chemical
                manufacturing, metal cleaning, food processing, and water
                treatment. We offer high-purity{" "}
                <strong>Hydrochloric Acid</strong> in both{" "}
                <strong>liquid</strong> and{" "}
                <strong>industrial concentrations</strong>, ensuring it meets
                the needs of various industrial applications. Our HCl is sourced
                from trusted manufacturers and is known for its consistency,
                reliability, and effectiveness in removing rust, scaling, and
                other impurities. Available in a range of grades and packaging
                sizes, we provide tailored solutions for bulk orders or smaller
                quantities. With stringent quality controls and safe handling
                procedures, we guarantee safe, on-time delivery. Contact us for
                more details or bulk order inquiries.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Hydrogen Peroxide ( Megh mani , NPL & Tanlcer lood.)</h3>
              <img
                src={hydrogenPeroxide}
                alt="hydrogenPeroxide"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Hydrogen Peroxide</strong> is a powerful oxidizing agent
                used in a wide range of applications, including bleaching,
                disinfection, and wastewater treatment. We offer high-quality{" "}
                <strong>Hydrogen Peroxide</strong> sourced from trusted
                manufacturers like <strong>Megh Mani</strong>,{" "}
                <strong>NPL</strong>, and <strong>Tanlcer Lood</strong>,
                ensuring reliability and consistent performance. Available in
                various concentrations, our product is ideal for industries such
                as textiles, food processing, and healthcare. Whether you
                require Hydrogen Peroxide for industrial cleaning,
                sterilization, or environmental applications, we provide it in
                convenient packaging options, including bulk quantities. With
                stringent quality controls and safe handling practices, we
                ensure the safe and timely delivery of our products. Contact us
                for more information or bulk order inquiries.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Maize Starch</h3>
              <img
                src={maizeStarch}
                alt="maizeStarch"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Maize Starch</strong>, derived from corn, is a highly
                versatile and essential ingredient used in a wide range of
                industries, including food, pharmaceuticals, textiles, and paper
                manufacturing. Our <strong>Maize Starch</strong> is sourced from
                reliable suppliers and is available in both{" "}
                <strong>powdered</strong> and <strong>granulated</strong> forms
                to meet diverse industrial needs. It is commonly used as a
                thickening agent in food products, a binder in pharmaceuticals,
                and as a key component in adhesives and coatings. With
                consistent quality, excellent performance, and a range of
                packaging options, we ensure that our Maize Starch meets the
                highest industry standards. We offer both bulk supply and
                smaller packaging, catering to your specific requirements.
                Contact us for detailed specifications or bulk order inquiries.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Oxalic Acid</h3>
              <img
                src={oxalicAcid}
                alt="oxalicAcid"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Oxalic Acid</strong> is a strong organic acid widely
                used for cleaning, bleaching, and metal treatment across various
                industries. Known for its excellent stain-removing and
                rust-cleaning properties, it is commonly used in textile,
                leather, and surface treatment applications. We supply
                high-purity <strong>Oxalic Acid</strong> in both{" "}
                <strong>crystal</strong> and <strong>powder forms</strong>,
                sourced from trusted manufacturers to ensure consistent quality
                and performance. It is also used in pharmaceutical formulations,
                as a reducing agent, and in certain laboratory processes.
                Available in durable, moisture-resistant packaging, we offer
                flexible supply options for both small and bulk requirements.
                With prompt delivery and competitive pricing, we support your
                operational needs with reliable service. Contact us for
                specifications, safety data, or order details.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Precipitated Silica</h3>
              <img
                src={precipitatedSilica}
                alt="precipitatedSilica"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Precipitated Silica</strong> is a synthetic, amorphous
                form of silicon dioxide produced through controlled chemical
                reactions involving silicate solutions and acids. It appears as
                a fine, white, powdery substance with high purity and a porous
                structure. Known for its excellent reinforcing properties, it is
                widely used in rubber, tire, and footwear manufacturing. It also
                serves as a thickening, anti-caking, and free-flow agent in
                food, pharmaceuticals, and cosmetics. Precipitated silica
                enhances product performance through improved texture,
                stability, and durability. Its high surface area and chemical
                stability make it an ideal choice for various industrial
                applications. Custom grades are available to suit specific
                formulation needs.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Precipitated Calcium Carbonate</h3>
              <img
                src={precipitatedCalciumCarbonate}
                alt="precipitatedCalciumCarbonate"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Precipitated Calcium Carbonate (PCC)</strong> is a
                high-purity, synthetic form of calcium carbonate produced by a
                controlled chemical reaction between calcium hydroxide and
                carbon dioxide. It appears as an ultra-fine, white powder with
                uniform particle size and excellent dispersion properties. PCC
                is widely used in paper, plastics, paints, rubber, and adhesives
                as a functional filler and coating pigment. It improves
                brightness, opacity, surface finish, and mechanical strength of
                end products. In pharmaceuticals and food industries, PCC is
                valued for its purity and bioavailability. Its fine particle
                size and customizable morphology make it suitable for
                specialized industrial formulations. We offer PCC in various
                grades to meet specific application requirements.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>SLES Powder & Liquid</h3>
              <img
                src={slesPowder}
                alt="slesPowder"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Sodium Lauryl Ether Sulfate (SLES)</strong> is a widely
                used anionic surfactant available in both{" "}
                <strong>powder</strong> and <strong>liquid forms</strong>. It is
                known for its excellent foaming, emulsifying, and cleansing
                properties, making it a key ingredient in personal care products
                such as shampoos, body washes, and toothpastes. SLES is also
                extensively used in household cleaners, detergents, and
                industrial cleaning solutions. The <strong>liquid form</strong>{" "}
                offers ease of formulation and fast solubility, while the{" "}
                <strong>powder form</strong> ensures better handling, longer
                shelf life, and reduced shipping costs. Both forms are highly
                effective in removing oils and dirt while being gentle on skin.
                We supply SLES in customizable concentrations to meet diverse
                formulation needs.
              </p>
            </div>
            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Sulphamic Acid</h3>
              <img
                src={sulphamicAcid}
                alt="sulphamicAcid"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Sulphamic Acid</strong> is a versatile, non-volatile,
                white crystalline solid widely used as a cleaning and descaling
                agent in industrial and household applications. It offers
                excellent efficiency in removing limescale, rust, and mineral
                deposits without producing toxic fumes. Commonly used in the
                maintenance of boilers, heat exchangers, and metal surfaces, it
                is also found in toilet cleaners, detergents, and electroplating
                processes. Sulphamic Acid is safe to handle, biodegradable, and
                less corrosive compared to strong mineral acids. Its stable
                nature and high purity make it ideal for controlled pH reduction
                and industrial cleaning formulations. We offer various grades to
                suit cleaning, industrial, and technical applications.
              </p>
            </div>

            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Sodium HypoChlorite</h3>
              <img
                src={sodiumHypoChlorite}
                alt="sodiumHypoChlorite"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Sodium Hypochlorite</strong> is a clear, pale
                yellow-green liquid commonly used as a powerful disinfectant and
                bleaching agent. It is widely applied in water treatment,
                sanitation, and cleaning industries for its strong oxidizing and
                antimicrobial properties. In household and industrial cleaning,
                it effectively removes stains, disinfects surfaces, and
                eliminates odors. It is also used in textile, pulp, and paper
                industries for bleaching and deodorizing. Sodium Hypochlorite
                plays a critical role in maintaining hygiene in municipal water
                systems and swimming pools. Available in various concentrations,
                it offers a cost-effective and reliable solution for large-scale
                disinfection and oxidation needs. We provide both industrial and
                commercial-grade options.
              </p>
            </div>

            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Technical Grade Urea</h3>
              <img
                src={technicalGradeUrea}
                alt="technicalGradeUrea"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Technical Grade Urea</strong> is a high-purity, white
                crystalline compound primarily used in industrial and chemical
                applications. Unlike agricultural-grade urea, it contains low
                levels of biuret and other impurities, making it suitable for
                resin production, adhesives, and as a raw material in
                formaldehyde-based compounds. It is widely used in the
                manufacture of urea-formaldehyde resins, melamine products, and
                coatings. Technical Grade Urea is also utilized in automotive
                systems (such as SCR for NOx reduction) and in various
                laboratory processes. It dissolves easily in water and offers
                consistent performance in industrial formulations. Available in
                various packaging sizes, it meets the stringent quality
                standards required for technical applications.
              </p>
            </div>

            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Titanium Di-oxide</h3>
              <img
                src={titaniumDioxide}
                alt="titaniumDioxide"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Titanium Dioxide (TiO₂)</strong> is a high-performance
                white pigment known for its exceptional brightness, opacity, and
                UV resistance. It is widely used in paints, coatings, plastics,
                paper, inks, and cosmetics due to its superior light-scattering
                properties. In the coatings and plastics industry, it enhances
                whiteness, gloss, and durability, while in sunscreens and
                cosmetics, it provides effective UV protection. Titanium Dioxide
                is available in <strong>rutile</strong> and{" "}
                <strong>anatase grades</strong>, each tailored for specific
                applications. It is chemically stable, non-toxic, and resistant
                to discoloration under UV light. We offer high-purity TiO₂
                grades that meet industrial and regulatory standards for
                performance and safety.
              </p>
            </div>

            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Lemon Chrome (Yellow Powder)</h3>
              <img
                src={lemonChromeYellowPowder}
                alt="lemonChromeYellowPowder"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Lemon Chrome (Yellow Powder)</strong> is a vibrant,
                yellow pigment primarily used in coatings, paints, and inks. It
                is known for its excellent color stability, bright hue, and high
                tinting strength, making it ideal for use in industrial and
                decorative applications. This pigment provides superior
                resistance to heat, light, and weathering, ensuring long-lasting
                color in both indoor and outdoor environments. Lemon Chrome is
                commonly used in automotive, construction, and art paints, as
                well as in the manufacturing of plastics and rubber. It is
                compatible with various solvents and resins, offering excellent
                dispersion. We supply high-quality Lemon Chrome pigment in
                powder form to meet diverse application needs.
              </p>
            </div>

            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Scarlet Chrome (Orange)</h3>
              <img
                src={scarletChromeOrange}
                alt="scarletChromeOrange"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Scarlet Chrome (Orange)</strong> is a vibrant,
                orange-colored pigment with exceptional brightness and high
                color strength. It is widely used in the production of paints,
                coatings, and inks, providing excellent durability and
                resistance to light and weathering. This pigment delivers
                outstanding performance in both indoor and outdoor applications,
                maintaining its vivid hue over time. Scarlet Chrome is commonly
                found in automotive paints, industrial coatings, plastics, and
                rubber products. It is compatible with various resins, solvents,
                and other materials, making it versatile for a range of
                formulations. Our high-quality Scarlet Chrome pigment is
                available in powder form, meeting the needs of various
                industrial and commercial applications.
              </p>
            </div>

            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Middle Chrome (Light yellow)</h3>
              <img
                src={middleChromeLightYellow}
                alt="middleChromeLightYellow"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Middle Chrome (Light Yellow)</strong> is a high-quality,
                light yellow pigment known for its bright, vibrant color and
                excellent opacity. It is commonly used in the production of
                paints, coatings, inks, and plastics, offering exceptional color
                stability and resistance to light and weathering. This pigment
                is ideal for use in automotive, industrial, and decorative
                coatings, where its light yellow tone provides a soft yet rich
                appearance. Middle Chrome delivers consistent performance and
                superior dispersion, making it highly compatible with various
                resins and solvents. It is a reliable choice for manufacturers
                seeking an economical and durable yellow pigment. We offer
                Middle Chrome in fine powder form to meet diverse application
                requirements.
              </p>
            </div>

            <div className="Minerals-Types-Card-Container-Mobile">
              <h3>Zinc Oxide</h3>
              <img
                src={zincOxide}
                alt="zincOxide"
                className="Minerals-Type-Image"
              />
              <p>
                <strong>Zinc Oxide (ZnO)</strong> is a versatile, white, powdery
                compound widely used in various industrial applications. It is
                known for its excellent UV-blocking properties, making it a key
                ingredient in sunscreens, cosmetics, and pharmaceuticals. Zinc
                Oxide also serves as a vital additive in rubber manufacturing,
                enhancing durability and resistance to heat and abrasion. In the
                paint industry, it improves the brightness and opacity of
                coatings. Additionally, it is used in the production of
                ceramics, glass, and electrical components due to its unique
                electrical properties. Zinc Oxide is chemically stable,
                non-toxic, and has antimicrobial properties, making it suitable
                for a broad range of applications. We offer high-purity Zinc
                Oxide to meet industrial and regulatory standards.
              </p>
            </div>
          </div>

          <Gettouch />
        </div>
      </div>
    </>
  );
};
export default Chemicals;
